<template>
  <div>
    <vs-popup title="Adicionar usuario" :active.sync="addTenantPopupActive">
    </vs-popup>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
      class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>Adicionar Tenant</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl" ref="formPS">
        <form @submit.prevent="addTenant" autocomplete="off">
          <div class="p-6" ref="form">
            <!-- NAME -->
            <vs-input label="Nome" v-model="tenant.name" class="mt-5 w-full" name="name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('name')">
              {{ errors.first('name') }}
            </span>

            <vs-input label="CNPJ" class="mt-5 w-full" type="text" v-model="tenant.cnpj" v-mask="['###.###.###-X#','##.###.###/####-##']"/>

            <div class="mt-5">
              <label class="vs-input--label">Templates</label>
              <v-select
                v-model="selectedTemplate"
                :options="templateOptions"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                name="template"
                placeholder=" "
                :clearable="false"
                :searchable="true"
                :reduce="option => option.value"
                label="text"
                @input="onTemplateChange"
              />
            </div>

            <div class="mt-5">
              <label class="vs-input--label">Plano</label>
              <v-select
                v-model="tenant.plan"
                :options="defaultPlans"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                name="plan"
                label="text"
                placeholder=" "
                :clearable="false"
                :searchable="true"
                :reduce="option => option.value"
              />
            </div>

            <div class="mt-5">
              <label class="vs-input--label">Importância do Cliente</label>
              <v-select
                v-model="selectedPriority"
                :options="tenantPriority"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="w-full"
                name="priority"
                v-validate="'required'"
                placeholder=" "
                :clearable="false"
                :searchable="true"
                :reduce="option => option.value"
                label="text"
                @input="onPriorityChange"
              />
              <span class="text-danger text-sm" v-show="errors.has('priority')">
                {{ errors.first('priority') }}
              </span>
            </div>

            <div class="flex flex-row mt-5 justify-between">
              <div>
                <label class="vs-input--label">Limite de Usuários</label>
                <vs-input-number class="userLimit" v-model="tenant.userLimit" min="0" max="100" step="5"/>
              </div>

              <div>
                <label class="vs-input--label">Limite de Atendimentos</label>
                <vs-input-number class="userLimit" v-model="tenant.ticketLimit" min="0" max="7000" step="500"/>
              </div>
            </div>

            <div class="mt-5">
              <div class="con-vs-alert no-message-alert mb-4 con-vs-alert-warning">
                <div class="vs-alert">
                  <p>A 'Importância do Cliente' definirá qual banco de dados ele irá pertencer.</p>
                  <p class="mt-3">Atualmente possuímos estas categorias:</p>
                  <li>Alta;</li>
                  <li>Média;</li>
                  <li>Baixa.</li>
                  <p class="mt-3">Selecione a categoria corresponde utilizando como base a TAG 'Importância do Cliente' proveniente do <b>CRM de Vendas</b>.</p>
                </div>
              </div>
            </div>
          </div>
        </form>
      </VuePerfectScrollbar>


      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="addData" :disabled="!isFormValid">
          Adicionar
        </vs-button>
        <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">
          Cancelar
        </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import { max } from 'lodash';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select';

import { mapGetters } from 'vuex'

export default {
  name: 'user-view-sidebar',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    tenant: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          name: '',
          cnpj: '',
          plan: 'BASIC',
          orders: false,
          userLimit: 50,
          smsAndEmail: false,
          ticketLimit: 1000
        }
      }
    },
    defaultPlans: {
      required: false,
      validator: prop => typeof prop === 'object' || prop === null,
      default() { return []; }
    }
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      addTenantPopupActive: false,
      selectedTemplate: '',
      selectedPriority: '',
      templateOptions: [
        { text: 'Template 1', value: 'template1' },
        { text: 'Template 2', value: 'template2' },
        { text: 'Template 3', value: 'template3' },
        { text: 'Template 4', value: 'template4' },
        { text: 'Venancio', value: 'venancio' }
      ],
      tenantPriority: [
        { text: 'Alta',  value: 'high' },
        { text: 'Média', value: 'medium' },
        { text: 'Baixa', value: 'low' },
      ],
      features: [
        {
          name:'Módulo de Sms/Email',
          activated: false,
          options: [6, 7]
        },
        {
          name:'Módulo de Pedidos',
          activated: false,
          options: [1, 2, 3]
        },
        {
          name:'Catálogo',
          activated: false,
          options: [4]
        },
        {
          name:'Maria',
          activated: false,
          options: [5]
        },
        {
          name:'Boehringer',
          activated: false,
          options: [8]
        },
        {
          name:'Farmacovigilância',
          activated: false,
          options: [9]
        },
      ]
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'users'
    ]),
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      const hasErrors = this.errors.any();
      const hasRequiredFields = this.tenant.name && this.tenant.cnpj && this.selectedTemplate && this.selectedPriority && this.tenant.userLimit && this.tenant.ticketLimit;
      
      return !hasErrors && hasRequiredFields;
    }
  },
  methods: {
    onTemplateChange(value) {
      this.selectedTemplate = value;
      this.$validator.validate('template');
    },
    onPriorityChange(value) {
      this.selectedPriority = value;
      this.$validator.validate('priority');
    },
    verify(){
      const permissions = localStorage.getItem('permissions');
      const twoFactor = localStorage.getItem('twoFactor')
      if(!permissions && !twoFactor){
          this.$router.push('/user-settings')
      }else if(!permissions && twoFactor){
          this.$router.push('/two-factor')
      }
    },
    initValues() {
      this.tenant = {
        id: null,
        name: '',
        cnpj: '',
        plan: 'BASIC',
        orders: false,
        userLimit: 50,
        smsAndEmail: false,
        ticketLimit: 1000
      }
    },
    addTenant() {
      this.addTenantPopupActive = true
    },
    async addData() {
      try {
        if (!this.tenant.name || !this.tenant.cnpj) {
          this.$vs.loading.close()
          return this.$vs.notify({
            title: 'Erro',
            text: 'Nome e CNPJ são obrigatórios.',
            color: 'danger'
          });
        }

        if (!this.selectedTemplate) {
          this.$vs.loading.close()
          return this.$vs.notify({
            title: 'Erro',
            text: 'É obrigatório selecionar um template.',
            color: 'danger'
          });
        }

        if (!this.selectedPriority) {
          this.$vs.loading.close()
          return this.$vs.notify({
            title: 'Erro',
            text: 'É obrigatório selecionar a importância do cliente.',
            color: 'danger'
          });
        }

        if (!this.tenant.userLimit || this.tenant.userLimit <= 0) {
          this.$vs.loading.close()
          return this.$vs.notify({
            title: 'Erro',
            text: 'O limite de usuários deve ser maior que zero.',
            color: 'danger'
          });
        }

        this.$vs.loading();
        await this.$store.dispatch('addTenant', {
          token: this.token,
          name: this.tenant.name,
          cnpj: this.tenant.cnpj,
          features: JSON.stringify(this.features),
          template: this.selectedTemplate,
          pool: this.selectedPriority,
          userLimit: this.tenant.userLimit,
          plan: this.tenant.plan,
          ticketLimit: this.tenant.ticketLimit
        }).then(() => {
          this.$store.dispatch('getAllTenants', { token: this.token });
          this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: 'Tenant criado com sucesso!'
          });
        }).catch((exception) => {
          console.error(exception)
          this.$vs.notify({
            color: 'danger',
            title: 'Erro!',
            text: 'Ocorreu um erro ao criar um novo Tenant!'
          });
        });

        this.isSidebarActiveLocal = false;
        this.$vs.loading.close();
      } catch (Exception) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Erro',
          text: 'Ocorreu um erro inesperado, entre em contato com nossa equipe',
          color: 'danger'
        });
      }
    },
  },
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  mounted(){
    this.verify();
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
.custom-select {
  position: relative;
  width: 100%;
}
.custom-select-font{
  font-size: 12px;
  color: #333;
}

.custom-select select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 38px;
  padding: 8px;
  width: 100%;
  cursor: pointer;
  outline: none;
}

.custom-select select:focus {
  border-color: #007BFF;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.4);
}

.select-arrow {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #333;
  pointer-events: none;
}

.userLimit {
  width: 7.6em;
}

</style>
